module.exports = '/ggmpa';


// WEBPACK FOOTER //
// ./src/context.js